
function encodeURI (obj) {
    return Object.keys(obj).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key])).join('&')
}
/*
Inspired by
    http://blog.garstasio.com/you-dont-need-jquery/ajax/#sending-and-receiving-json
    https://github.github.io/fetch/
    https://xhr.spec.whatwg.org/
*/
export default function xhr ({ url, method = 'GET', body, bodyType, async = true, username = null, password = null }) {
    return new Promise((resolve, reject) => {
        if (!url) {
            return reject(new Error('No URL provided'))
        }
        const request = new XMLHttpRequest()
        const params = []
        if (username) {
            params.push(username)
            if (password) {
                params.push(password)
            }
        }
        request.open(method, url, async, ...params)
        if (body) {
            let contentType
            switch (bodyType) {
            case 'json':
                contentType = 'application/json;charset=UTF-8'
                body = JSON.stringify(body)
                break
            case 'form':
                contentType = 'multipart/form-data'
                body = encodeURI(body)
                break
            default:
                contentType = 'application/x-www-form-urlencoded;charset=UTF-8'
                body = encodeURI(body)
                break
            }
            request.setRequestHeader('Content-Type', contentType)
        }
        request.onload = () => {
            if (request.status >= 200 && request.status < 400) {
                let response = request
                if (~request.getResponseHeader('Content-Type').indexOf('json') || url.substr(-4) === 'json') {
                    response = JSON.parse(request.responseText)
                }
                resolve(response)
            } else {
                reject(new Error(request.statusText))
            }
        }
        request.onerror = () => reject(new Error('Connection error'))
        request.send(body)
    })
}
